import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/beach-bandits/intro_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={655}
              height={507}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#63CB51" }}>Introduction</span>
            </h2>
            <p>
              How many times was your beach trip ruined because you didn’t have
              your beach stuff? Once you download beach bandits, you will be
              able to get any beach accessory and equipment you might need with
              just a few clicks.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
